export { Avatar, AvatarFallback, AvatarImage } from "./avatar";
export type { AvatarVariant } from "./avatar";
